export const styles = {
    additionalAddress: {
        m: 2,
        fontSize: "small",
        fontWeight: "semibold",
        right: 0,
        bottom: 0,
        textAlign: "start",
        cursor: "pointer",
        color: "gray.500",
        transition: "color 0.2s",
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        _hover: {
            color: "black",
            TextDecorationColor: "black",
        },
    },
    // Same font size/weight as the field labels, keeping the link affordance.
    // block so the button's vertical margins collapse like the other fields;
    // mt matches the field top gap; mb gives the larger bottom gap from the
    // Figma reference (the collapsed trigger reads as its own field row).
    additionalAddressTrigger: {
        display: "block",
        mt: 4,
        mb: 7,
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
        fontWeight: "bold",
        textAlign: "start",
        cursor: "pointer",
        color: "gray.500",
        transition: "color 0.2s",
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        _hover: {
            color: "black",
            textDecorationColor: "black",
        },
    },
    // Wraps the expanded label + input as one field. Provides the field's top
    // gap and zeroes the input FormControl's default top margin so the label ->
    // input distance is only the label's mb, matching the other fields.
    additionalAddressExpandedWrapper: {
        mt: 4,
        "& .chakra-form-control": {
            mt: 0,
        },
    },
    // Expanded state: reads as a field label; underline only appears on hover.
    // block + no top margin — the wrapper provides the field's top spacing, and
    // mb matches the other labels' gap to their input. textDecoration none so it
    // is not underlined at rest (the link variant underlines by default).
    additionalAddressExpandedLabel: {
        display: "block",
        mb: 2,
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
        fontWeight: "bold",
        textAlign: "start",
        cursor: "pointer",
        color: "gray.500",
        transition: "color 0.2s",
        textDecoration: "none",
        textUnderlineOffset: "4px",
        _hover: {
            color: "black",
            textDecoration: "underline",
            textDecorationColor: "black",
        },
    },
    fieldsWrapper: {
        w: {
            base: "100%",
            md: "60%",
        },
        mt: 7,
    },
    fieldWrapper: {
        mt: 4,
    },
    formLabel: {
        mb: 2,
    },
    formInput: {
        color: "gray.500",
        _selected: {
            outline: "none",
        },
    },
    richText: {
        "p:last-child": {
            mb: 0,
        },
        table: {
            mb: 3,
            p: {
                mb: 0,
            },
        },
        tr: {
            textAlign: "left",
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
            borderBottomColor: "gray.200",
            ":last-child": {
                border: "none",
            },
            ":first-child": {
                border: "none",
            },
        },
        td: {
            py: 2,
            verticalAlign: "middle",
        },
    },
    dropdownStyle: {
        _disabled: {
            backgroundColor: "gray.100",
            cursor: "not-allowed",
            width: "100%",
            border: "1",
            height: [8.4, 10.4],
            borderColor: "gray.400",
            color: "gray.600",
            justifyContent: "space-between",
            p: {
                fontWeight: "semibold",
            },
        },
        _hover: { borderColor: "black" },
        backgroundColor: "white",
        borderColor: "gray.500",
        height: [9.6, 10.4],
        w: "100%",
    },
    streetNumberReminder: {
        fontSize: "mobileBodyB4",
        pl: 2,
    },
};
